import { VCol } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCol,{staticClass:"card pa-0"},[_c('div',{staticClass:"lu-card-list"},[_c('div',{staticClass:"lu-scroll pb-2"},[_c('IuSelect'),_c('IuLink'),_c('IuLegend'),_c('IuOpacity'),_c('IuNavi')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }